import React from "react";
import Select from "react-select";

export default class AutoComplete extends React.Component {
    state = {
        selectedOption: null,
    }
    constructor(props) {
        super(props)
        this.state = {
            modifiedOption: this.getModifiedOptions()
        }
    }
    getModifiedOptions = () => {
        let { options } = this.props;
        let optionsToReturn = [];
        for (var key in options) {
            optionsToReturn.push({
                value: key,
                label: options[key]
            })
        }
        return optionsToReturn;
    }
    handleChange = (selectedOption) => {
        let { onChange } = this.props;
        let valueToSave = void 0;
        if (Array.isArray(selectedOption)) {
            valueToSave = [];
            for (let i = 0; i < selectedOption.length; i++) {
                let val = selectedOption[i].value;
                valueToSave.push(val);
            }
        } else {
            valueToSave = selectedOption.value
        }
        onChange && onChange(valueToSave);
    }

    getValue = () => {
        let { options, value } = this.props;
        if (Array.isArray(value)) {
            return value.map(val => {
                if (val) {
                    return {
                        value: val,
                        label: options[val]
                    }
                }
            })
        } else {
            return {
                value,
                "label": options[value]
            }
        }
    }
    onBlur = () => {
        let { value, onBlur } = this.props;
        onBlur && onBlur(value);
    }
    onFocus = () => {
        this.props.onFocus && this.props.onFocus();
    }
    render() {
        const { modifiedOption } = this.state;
        let { editable = true, multi, placeholder, value, isSearchable } = this.props;
        let valueToShow = value && this.getValue();
        return (
            <Select
                isSearchable={isSearchable}
                isClearable={false}
                value={valueToShow}
                isDisabled={editable === false ? true : false}
                isMulti={multi}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                placeholder={placeholder}
                onChange={this.handleChange}
                options={modifiedOption}
            />
        )
    }
}